module.exports = __webpack_public_path__ + "adea69c8d35c1cfa32ee173db7ac457b.png";